import React from 'react';
import { Handle, Position } from 'reactflow';
import { Globe } from 'lucide-react';

const ApiNode = ({ data, isConnectable }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-gray-200 node-api">
      <div className="flex items-center">
        <Globe className="w-4 h-4 text-gray-600 mr-2" />
        <div className="ml-2">
          <div className="text-lg font-bold text-gray-800">External API</div>
          <div className="text-sm text-gray-600">
            {data.config?.url || 'Configure API endpoint'}
          </div>
          <div className="text-xs text-gray-600">
            Method: {data.config?.method || 'GET'}
          </div>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Top}
        id="input"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-gray-500 border-2 border-white"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-gray-500 border-2 border-white"
      />
    </div>
  );
};

export default ApiNode;